import { render, staticRenderFns } from "./BillForm.vue?vue&type=template&id=1c41ea2a&scoped=true"
import script from "./BillForm.vue?vue&type=script&lang=js"
export * from "./BillForm.vue?vue&type=script&lang=js"
import style0 from "./BillForm.vue?vue&type=style&index=0&id=1c41ea2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41ea2a",
  null
  
)

export default component.exports